export const recalculateSellingPrice = (listedPrice, discountValue) => {
  const price = parseFloat(listedPrice) || 0;

  const discount = String(discountValue);

  if (discount.includes("%")) {
    const percentage = parseFloat(discount.replace("%", "")) || 0;
    const discountAmount = (price * percentage) / 100;
    return reduceToFixedDecimals(price - discountAmount);
  } else {
    const fixedDiscount = parseFloat(discount) || 0;
    return reduceToFixedDecimals(price - fixedDiscount);
  }
};

const reduceToDecimalPlacesValue = 2;
export const reduceToFixedDecimals = (amount) => {
  if (isNaN(amount)) return amount;
  return Number(Number(amount).toFixed(reduceToDecimalPlacesValue));
};
